






















































import { Component, Vue } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import SingleWord from "@/components/cards/SingleWord.vue";
import * as data from "@/model/englishjanala/englishjanala.json";
import axios from "axios";
import { Notify } from "vant";
import NewWord from "@/components/modals/NewWord.vue";
import Spiner from "@/components/englishjanala/Spiner.vue";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  components: {
    sidebar,
    SingleWord,
    NewWord,
    Spiner,
  },
})
export default class Home extends Vue {
  CategoryId: any;
  Spiner: boolean = true;
  day: any;
  wordLevel: any;
  words: any = null;
  async mounted() {
    this.day = this.$route.params.day;
    const PassData = { day_of_the_month: this.day };
    // get all category list
    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/GetWordsOfTheDay",
      PassData
    );
    this.wordLevel = response.data.wordsOfTheDay;
    this.words = this.wordLevel.words;
    // this.words = this.words.isExpandable = false;
    console.log("words", this.words);
    this.Spiner = false;
    console.log(response.data);
  }

  // UpdateWords() {
  //   const data = { day: this.$route.params.day };

  //   const response = axios
  //     .post(
  //       "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/GetWordsOfTheDay",
  //       data
  //     )
  //     .then()
  //     .catch((error) => {
  //       Notify({ type: "danger", message: "Word Level is not Updated" });
  //     });
  //   Notify({ type: "success", message: "Word Level Updated" });
  // }

  get CategoryID() {
    this.CategoryId = this.$route.params.CategoryId;
    return this.$route.params.CategoryId;
  }
  get WordLevel() {
    return this.$route.params.LevelId;
  }

  get getWords() {
    return data.wordCategories.filter((item) => {
      return item.id == this.CategoryId;
    });
  }
  get RouteParam() {
    return this.$route.params;
  }
  getImgUrl(item: any) {
    return item.imageUrl;
  }

  UpdateDayWord() {
    const data = {
      words_of_the_day: {
        day: this.day,
        words: this.words,
      },
    };

    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/PutWordsOfTheDay",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Word is not added in days" });
      });
    Notify({ type: "success", message: "Word is added in days" });
  }
}
